// Event names and property shapes for query permit telemetry.

// event names
export const QUERY_PERMIT_SOFT_THROTTLE_EVENT = `query_permit.soft_throttle`;

// properties
export enum QueryPermitClientType {
  SharedWorker = `SHARED_WORKER`,
  Local = `LOCAL`,
}

export interface SoftThrottleEventProps {
  project_id: number;
  client_type: QueryPermitClientType;
  // Number of queries that were throttled
  engaged_count: number;
  // Histogram of engaged grants by backoff depth level
  backoff_level_1: number;
  backoff_level_2: number;
  backoff_level_3: number;
  backoff_level_4: number;
  backoff_level_5_plus: number;
  // Query rate over the flush window
  sustained_rpm: number;
}

export type QueryPermitTrackEvent = {
  name: typeof QUERY_PERMIT_SOFT_THROTTLE_EVENT;
  properties: SoftThrottleEventProps;
};
